import axios from "axios";
export default class OrderItemService {
    updateOrderItem(orderId, cartItem, orderItemId) {
        return axios.post("/order/item/update", cartItem, {
            params: {
                orderId: orderId,
                orderItemId: orderItemId
            },
            withCredentials: true
        });
    }
    addOrderItem(orderId, cartItem) {
        return axios.post("/order/item/add", cartItem, {
            headers: { 'Content-Type': 'application/json' },
            params: {
                orderId: orderId
            },
            withCredentials: true
        });
    }
    addCustomOrderItem(orderId, customItem) {
        return axios.post("/order/item/custom", customItem, {
            headers: { 'Content-Type': 'application/json' },
            params: {
                orderId: orderId
            },
            withCredentials: true
        });
    }
    deleteOrderItem(orderId, orderItemId) {
        return axios.post("/order/item/remove", null, {
            headers: { 'Content-Type': 'application/json' },
            params: {
                orderId: orderId,
                orderItemId: orderItemId
            },
            withCredentials: true
        });
    }
}
